import {
  createAsyncThunk,
  createReducer,
} from '@reduxjs/toolkit'

import { Group } from '@/model/group'
import { axios } from '@/utils/axios'
import {
  removeItem,
  updateOrAddArrayItem,
} from '@/utils/draft'

import { createAppAsyncThunk } from './utils'

const namespace = 'group'

export const readAllGroups = createAppAsyncThunk(
  `${namespace}/readAllGroups`,
  async () => {
    const { data } = await axios.get<Group[]>('/group/all')
    return data
  },
)
export interface CreateGroupParams extends Omit<Group, 'id' | 'status'> {
  parentId: number
}
export const createGroup = createAsyncThunk(
  `${namespace}/createGroup`,
  async (data: CreateGroupParams) => (await axios.post<Group>(
    '/group',
    data,
  )).data,
)
export type UpdateGroupParams = Omit<Group, 'organizationId' >
export const updateGroup = createAsyncThunk(
  `${namespace}/updateGroup`,
  async (data: UpdateGroupParams) => (await axios.put<Group>(
    `/group/${data.id}`,
    data,
  )).data,
)
export const removeGroup = createAsyncThunk(
  `${namespace}/removeGroup`,
  async (id: number) => await axios.delete(`/group/${id}`),
)

const initialState: {
  groups: Group[]
} = {
  groups: [],
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readAllGroups.fulfilled, (draft, { payload }) => {
    draft.groups = payload
  })
  builder.addCase(createGroup.fulfilled, (draft, { payload }) => {
    draft.groups.push(payload)
  })
  builder.addCase(updateGroup.fulfilled, (draft, { payload }) => {
    updateOrAddArrayItem(payload, draft.groups)
  })
  builder.addCase(removeGroup.fulfilled, (draft, { meta }) => {
    removeItem(meta.arg, draft.groups)
  })
})

export default { [namespace]: reducer }
